module.exports = __webpack_public_path__ + "static/RiskOfRain1-dfc9c712fa94ce4b2dcbd3b462edfcaf.png";